import { useQuery } from '@tanstack/react-query';
import {
  GetUserPermissionsEntity,
  UserWalletAuthService,
} from 'services/openapi';

import { UserServiceQueryKeys } from '../constants';

export const useGetAdminActionsQuery = (enabled = false) => {
  const queryKey = [UserServiceQueryKeys.GET_ADMIN_ACTIONS];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetUserPermissionsEntity, Error>({
    queryKey,
    queryFn: () => UserWalletAuthService.authControllerGetAdminActions(),
    // onSuccess: (data) => {
    //   localStorage.setItem(
    //     LocalStorageKey.ADMIN_ACTIONS,
    //     JSON.stringify(data?.adminActions || []),
    //   );
    // },
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey,
    refetch,
  };
};
